// assets/product-media-description-position.js
//
// A Product Description block nested inside the media gallery block (see
// blocks/_product-media-gallery.liquid) can optionally render with the product details column
// instead, on mobile only — desktop always keeps it in place. Pure CSS can't do this: the
// description is a DOM descendant of the media gallery block, not a sibling of the details
// column, so there's no shared flex/grid container to reorder it within. This just physically
// moves the wrapper element in and out of the details column as the viewport crosses the
// breakpoint, restoring it to its original spot (marked by a comment node) for desktop.
const MOBILE_BREAKPOINT = '(max-width: 749px)';

class ProductMediaDescriptionPosition {
  /** @param {HTMLElement} wrapper */
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.anchor = document.createComment('product-media-description-position-anchor');
    wrapper.before(this.anchor);
    this.mediaQuery = window.matchMedia(MOBILE_BREAKPOINT);
    this.mediaQuery.addEventListener('change', this.update);
    this.update();
  }

  update = () => {
    const wantsDetails = this.wrapper.dataset.mobileDescriptionPosition === 'details' && this.mediaQuery.matches;
    const detailsId = this.wrapper.dataset.productInformationId;
    // .group-block-content is where _product-details.liquid's own flex-laid-out fields (Shape,
    // price, buy buttons, etc. — see snippets/group.liquid) actually live; appending straight to
    // the #ProductInformation-* root instead would land beside .group-block as an unstyled
    // sibling, outside that flex layout entirely.
    const detailsContent = detailsId ? document.querySelector(`#${detailsId} .group-block-content`) : null;

    if (wantsDetails && detailsContent) {
      if (this.wrapper.parentElement !== detailsContent) detailsContent.append(this.wrapper);
    } else if (this.wrapper.previousSibling !== this.anchor) {
      this.anchor.after(this.wrapper);
    }
  };
}

document
  .querySelectorAll('.product-media-gallery__nested-blocks')
  .forEach((wrapper) => new ProductMediaDescriptionPosition(/** @type {HTMLElement} */ (wrapper)));
